"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GradeAndFeedbackCustomTime = void 0;
var _react = require("react");
var _hooks = require("../../../../../../../hooks");
var _DateTimePickers = require("../../../../../../../UI/DateTimePickers");
var _TaskManager = require("../../../../../TaskManager.provider");
var _GradeAndFeedbackCustomTime = _interopRequireDefault(require("./GradeAndFeedbackCustomTime.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GradeAndFeedbackCustomTime = props => {
  const {
    minDate = new Date(),
    maxDate
  } = props;
  const {
    task,
    setTask,
    setIsChanged,
    unitData,
    getLabel
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const isTimeEnable = task?.taskType === 'exam';
  const toDay = (0, _react.useRef)(new Date());
  const dpMinDate = new Date(Math.max(minDate.getTime(), toDay.current.getTime()));
  const dpMaxDate = maxDate || unitData?.schoolYear.endDate;
  const handleDateChange = date => {
    setIsChanged(true);
    setTask({
      ...task,
      feedbackDate: date
    });
  };
  const styles = (0, _GradeAndFeedbackCustomTime.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-TaskManager__grade-and-feedback-custom-time'],
    children: isTimeEnable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateTimePickers.DateTimePicker, {
      minDateTime: dpMinDate,
      maxDateTime: dpMaxDate,
      anchorSubTextDate: getLabel('text_label_date'),
      anchorSubTextTime: getLabel('text_label_time'),
      datePickerTitle: "",
      timePickerTitle: getLabel('text_label_time'),
      dateTime: task?.feedbackDate,
      onChange: handleDateChange,
      minutesStep: 5,
      isDisabled: task?.isReadOnly,
      btnProps: {
        customStyle: {
          width: isMobileView ? '100%' : 'auto'
        }
      }
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateTimePickers.DatePicker, {
      view: "menu",
      minDate: dpMinDate,
      maxDate: dpMaxDate,
      anchorSubText: getLabel('text_label_date'),
      selectedDate: task?.feedbackDate,
      onChange: handleDateChange,
      isDisabled: task?.isReadOnly
    })
  });
};
exports.GradeAndFeedbackCustomTime = GradeAndFeedbackCustomTime;